import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';

class DownArrow extends Component {
  static propTypes = {
    arrowState: PropTypes.string,
    onOpenClick: PropTypes.func,
    onCloseClick: PropTypes.func
  };

  componentWillMount() {
    this.setState({
      display: this.props.arrowState || 'arrow'  //Display the arrow by default
    });
  }

  _setArrowState(state){
    this.setState({
      display: state
    });
  }

  _onClick() {
    let newState = {};

    if (this.props.arrowState || this.state.display === 'arrow') {
      newState.display = 'cross';
      this.props.onOpenClick && this.props.onOpenClick();
    } else {
      newState.display = 'arrow';
      this.props.onCloseClick && this.props.onCloseClick();
    }

    this.setState(newState);
  }

  render() {
    const arrowState = this.props.arrowState || this.state.display;
    const classes = classNames("down-arrow", {"close-arrow": (arrowState !== "arrow")});

    return (
      <a className={classes} onClick={this._onClick.bind(this)}>
        <div className="down-arrow-lines"></div>
      </a>
    );
  }
}

export default DownArrow;



// WEBPACK FOOTER //
// ./app/components/shared/DownArrow.js